import { CircleX } from "lucide-react";
import { applyAuth0Theme } from "@/utils/theme";
import { useResetPasswordErrorManager } from "./hooks/resetPasswordErrorManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function ResetPasswordErrorScreen() {
    const { resetPasswordError, texts, locales } = useResetPasswordErrorManager();
    applyAuth0Theme(resetPasswordError);

    const description = texts?.description || locales.header.description;

    return (
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>
            <div className="auth-view text-center">
                <div className="flex justify-center mb-6 mt-4 text-(--ul-theme-color-error)">
                    <CircleX size={80} strokeWidth={1} />
                </div>
                <p className="auth-code-prompt">
                    {description}
                </p>
            </div>
        </AuthLayout>
    );
}

export default ResetPasswordErrorScreen;
